module.exports = __webpack_public_path__ + "img/motsu_curry.8be7daf1.jpg";